import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Something_went_wrong, Request_Thank_You } from "@root/app.constant";
import { Urls } from '../../../utils/urls';
import { ApiService } from '../../../shared/services/api.service';
import { CommonDataService } from '../../../shared/services/common-data.service';
import { environment } from '../../../../environments/environment.prod'

@Component({
  selector: 'app-write-us-mobile',
  templateUrl: './write-us-mobile.component.html',
  styleUrls: ['./write-us-mobile.component.scss']
})
export class WriteUsMobileComponent implements OnInit {
  userData: any = {};
  mobNumberPattern = "^((\\+91-?)|0)?[6-9][0-9]{9}$";
  alphaPattern = '^[a-zA-Z ]*$';
  msgPattern = '^[a-zA-Z\\,\\.\\_\\;\\- ]*$';
  firstName: string;
  lastName: string;
  cityList = [
    {
      displayName: 'Bangalore',
      value: 1
    },
    {
      displayName: 'Mumbai',
      value: 2
    }
];
reasonList = [];
  constructor(
    public apiService: ApiService,
    private toastr: ToastrService,
    public commonDataService: CommonDataService) { }

  ngOnInit() {
    this.getCity();
    window.scrollTo(0, 0);
  }

  getCity = () => {
    this.apiService.postData(Urls.getCity, {stateId : 0}).subscribe((response: any) => {
      this.cityList = response.data.cityList;
      this.getReasons();
    });
  }

  getReasons = () => {
    this.apiService.getData(Urls.getReasons).subscribe((response: any) => {
      this.reasonList = response.data.reasons;
    });

  }

  investOnline = () => {
    if(!environment.isDRBuild){
      window.open("https://investonline.itiamc.com/", "_blank");
    }else{
      window.open("https://drinvestor.itiamc.com/", "_blank"); //DR-inv
    }
  }

  processForm = () => {
    this.userData.name = this.firstName + ' ' + this.lastName;

    this.apiService.postData(Urls.postWriteUs, this.commonDataService.convertToString(this.userData)).subscribe((response: any) => {
      if (response.status === 0) {
        this.toastr.success(Request_Thank_You);
      } else {
        this.toastr.error(Something_went_wrong);
      }
    });

  }

}
